module.exports = __webpack_public_path__ + "img/nueva-zelanda.23ba2183.png";